export default "__VITE_ASSET__5dg1hN4t__"